// extracted by mini-css-extract-plugin
module.exports = {"marketing-page":"ccfda6eb9f--marketing-page--xhfsi"};